import React, { Component } from "react";
import TagsInput from 'react-tagsinput'

import '../../css/utils/react-tagsinput.css' // If using WebPack and style-loader.

export default class KeywordsInput extends Component {
  constructor() {
    super()
    this.state = {tags: []}
  }

  componentWillReceiveProps(nextProps) {
      var tags = nextProps.tags;

      this.setState({tags: tags})
  }

  handleChange = (tags) => {
      //console.log("tags: " + tags);

      this.props.getKeywords(tags)
  }

  render() {
    return <TagsInput value={this.state.tags} onChange={this.handleChange.bind(this)} />
  }
}



// WEBPACK FOOTER //
// ./src/components/exercise/KeywordsInput.js